import { Component } from '@angular/core';

@Component({
  selector: 'op-security-management',
  templateUrl: './security-management.component.html'
})
export class SecurityManagementComponent {

}
